import * as api from "../../../api";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import Profile from "../../Translator/Profile/Profile";

import {
  ALERT,
  COUNTER,
  REMOVE_UNASSIGNED_QUOTES,
  REMOVE_URGENT_QUOTES,
  REMOVE_INCOMPLETE_QUOTES,
  UPDATE_INCOMPLETE_QUOTES,
  REMOVE_DECLINED_QUOTES,
} from "../../../constants/actionTypes";

import {
  CancelOutlined,
  KeyboardArrowDown,
  KeyboardArrowLeft,
} from "@material-ui/icons";

import "./Allocate.css";

const Allocate = ({
  showAllocation,
  setShowAllocation,
  quote,
  urgent,
  unassigned,
  allocations,
  declined,
  quotesLength,
}) => {
  dayjs.extend(relativeTime);
  const counter = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const history = useHistory();
  const [translators, setTranslators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allocating, setAllocating] = useState(false);
  const [reviewDate, setReviewDate] = useState("");
  const [selected, setSelected] = useState([]);
  const [infoType, setInfoType] = useState("");
  const [showProfile, setShowProfile] = useState(false);
  const [profile, setProfile] = useState({});
  const [skip, setSkip] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  const declinedTranslators = quote.allocation?.declined_msg
    ? quote.allocation.declined_msg.map((message) => message.translator)
    : [];
  const disable =
    reviewDate === "" ||
    selected.length < 1 ||
    selected.filter(
      (select) => select.price === "" || select.price === undefined
    ).length > 0 ||
    allocating;
  const errorMsg = quote.allocation?.declined_msg
    ? quote.allocation.declined_msg.filter((msg) => msg.quote === quote._id)
    : [];
  const rating = (translator) =>
    translator.rating
      ? (
          translator.rating.total_stars / translator.rating.total_rating
        ).toFixed(2)
      : 0;

  const findTranslators = useCallback(async () => {
    try {
      if (!allocations && !declined) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.languageTo.join("|"),
          },
          skip: 0,
        });
        setTranslators(data);
        setLoading(false);
      }
      if (allocations) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.allocation.left_lang.join("|"),
          },
          skip: 0,
        });
        setTranslators(data);
        setLoading(false);
      }
      if (declined) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.allocation.declined_lang.join("|"),
          },
          skip: 0,
        });
        setTranslators(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  }, [dispatch, quote, allocations, declined]);

  const handleNextPage = async () => {
    try {
      if (!allocations && !declined) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.languageTo.join("|"),
          },
          skip: skip + 20,
        });
        setTranslators([...translators, ...data]);
      }
      if (allocations) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.allocation.left_lang.join("|"),
          },
          skip: skip + 20,
        });
        setTranslators([...translators, ...data]);
      }
      if (declined) {
        const { data } = await api.getTranslators({
          who: {
            role: "translator",
            source_lang: quote.languageFrom,
            "membership.approved": true,
            "workPlace.new_projects.0": { $exists: false },
            target_lang: quote.allocation.declined_lang.join("|"),
          },
          skip: skip + 20,
        });
        setTranslators([...translators, ...data]);
      }

      setSkip((skip) => skip + 20);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  const handleSelect = (translator) => {
    const isLangChosen = selected.findIndex(
      (select) => select.target_lang === translator.target_lang
    );

    if (isLangChosen !== -1)
      return dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "Translator for this language has already been selected",
          duration: 7000,
          display: true,
        },
      });
    setSelected([...selected, translator]);
  };

  const handleOpenProfile = (translator) => {
    setProfile(translator);
    setShowProfile(true);
  };

  const openModal = () => {
    document.querySelector(".allocate__details").style.zIndex = 4;
    document.querySelector(".allocate__details").open = true;
  };

  const closeModal = () => {
    document.querySelector(".allocate__details").style.zIndex = -1;
    document.querySelector(".allocate__details").open = false;
  };

  const handleShowInfo = (type) => {
    setInfoType(type);
    setShowMessage(true);
  };

  const handlePriceChange = (index, price) => {
    const selectedPrice = selected.map((select, i) => {
      if (index === i) select.price = price;

      return select;
    });

    setSelected(selectedPrice);
  };

  const disableSelect = (id) => {
    const translatorSelected = selected.findIndex(
      (translator) => translator._id === id
    );

    if (translatorSelected === -1) return false;
    else return true;
  };

  const removeTranslator = (id) => {
    const refinedSelected = selected.filter((select) => select._id !== id);

    setSelected(refinedSelected);
  };

  const handleAllocate = async () => {
    setAllocating(true);
    const leftLang = allocations
      ? quote.allocation.left_lang.filter(
          (lang) =>
            selected.map((select) => select.target_lang).includes(lang) ===
            false
        )
      : quote.languageTo.filter(
          (lang) =>
            selected.map((select) => select.target_lang).includes(lang) ===
            false
        );
    const declinedLang = declined
      ? quote.allocation.declined_lang.filter(
          (lang) =>
            selected.map((select) => select.target_lang).includes(lang) ===
            false
        )
      : [];

    const contributors = selected.map((select) => {
      const refinedAllocated = {
        translator: {
          id: select._id,
          name: select.name,
          email: select.email,
        },
        amount:
          select.price *
          (quote.totalPages ? quote.totalPages : quote.totalCount),
        price: select.price * 1,
        language: select.target_lang,
        reviewDate,
      };

      return refinedAllocated;
    });

    try {
      if (!declined) {
        const { data } = await api.updateQuote(quote.id, {
          status: "ongoing",
          contributors: [...quote.contributors, ...contributors],
          reviewDate,
          allocation: {
            completed: leftLang.length > 0 ? false : true,
            left_lang: leftLang,
          },
        });

        data.contributorsId.forEach(async (contributor) => {
          if (
            !quote.contributors
              .map((contributor) => contributor._id)
              .includes(contributor)
          ) {
            await api.awaiting({ $push: { awaiting_projects: contributor } });
          }
        });
      }

      if (declined) {
        const { data } = await api.updateQuote(quote.id, {
          status: "ongoing",
          contributors: [...quote.contributors, ...contributors],
          reviewDate,
          allocation: {
            ...quote.allocation,
            declined: declinedLang.length > 0 ? true : false,
            declined_lang: declinedLang,
          },
        });

        data.contributorsId.forEach(async (contributor) => {
          if (
            !quote.contributors
              .map((contributor) => contributor._id)
              .includes(contributor)
          ) {
            await api.awaiting({ $push: { awaiting_projects: contributor } });
          }
        });
      }

      selected.forEach(
        async (translator) =>
          await api.updateUser(translator._id, {
            $push: { "workPlace.new_projects": quote.id },
          })
      );

      if (quote.status !== "ongoing") {
        await api.counter({ ongoing_projects: 1 });
        dispatch({
          type: COUNTER,
          payload: { ...counter, ongoing_projects: counter.ongoing_projects++ },
        });
      }

      if (leftLang.length > 0 && !allocations) {
        await api.counter({ incomplete_allocations: 1 });
        dispatch({
          type: COUNTER,
          payload: {
            ...counter,
            incomplete_allocations: counter.incomplete_allocations + 1,
          },
        });
      }

      if (declinedLang.length < 1 && declined) {
        await api.counter({ declined_allocations: -1 });
        dispatch({
          type: COUNTER,
          payload: {
            ...counter,
            declined_allocations: counter.declined_allocations - 1,
          },
        });
      }

      if (declined) {
        if (quotesLength < 2) history.push("/admin/index");
        dispatch({ type: REMOVE_DECLINED_QUOTES, id: quote.id });
      }

      if (leftLang.length > 0 && allocations) {
        dispatch({
          type: UPDATE_INCOMPLETE_QUOTES,
          id: quote.id,
          payload: {
            completed: leftLang.length > 0 ? false : true,
            left_lang: leftLang,
          },
        });
      }

      if (allocations && leftLang.length < 1) {
        await api.counter({ incomplete_allocations: -1 });
        dispatch({
          type: COUNTER,
          payload: {
            ...counter,
            incomplete_allocations: counter.incomplete_allocations - 1,
          },
        });
        if (quotesLength < 2) history.push("/admin/index");
        dispatch({ type: REMOVE_INCOMPLETE_QUOTES, id: quote.id });
      }

      if (unassigned) {
        selected.forEach(
          async (translator) =>
            await api.sendEmail({
              name: translator.name,
              email: translator.email,
              message: `Congratulations you have been allocated a project on your OneConverse Translations plathform. Please review and accept before the next 3 hours to avoid reversal`,
              subject: "Project Allocated - OneConverse Translations",
            })
        );

        await api.counter({ unassigned_projects: -1 });
        dispatch({
          type: COUNTER,
          payload: {
            ...counter,
            unassigned_projects: counter.unassigned_projects - 1,
          },
        });
        if (quotesLength < 2) history.push("/admin/index");
        dispatch({ type: REMOVE_UNASSIGNED_QUOTES, id: quote.id });
      }

      if (urgent) {
        selected.forEach(
          async (translator) =>
            await api.sendEmail({
              name: translator.name,
              email: translator.email,
              message: `Congratulations you have been allocated a project on your OneConverse Translations plathform. Please review and accept before the next 3 hours to avoid reversal`,
              subject: "Project Allocated - OneConverse Translations",
            })
        );

        await api.counter({ urgent_projects: -1 });
        dispatch({
          type: COUNTER,
          payload: { ...counter, urgent_projects: counter.urgent_projects - 1 },
        });
        if (quotesLength < 2) history.push("/admin/index");
        dispatch({ type: REMOVE_URGENT_QUOTES, id: quote.id });
      }

      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Project assigned successfully",
          duration: 5000,
          display: true,
        },
      });
      setShowAllocation(false);
    } catch (error) {
      console.log(error);
      setAllocating(false);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  useEffect(() => {
    if (showAllocation && translators < 1) findTranslators();
    else setLoading(false);
  }, [showAllocation, translators, findTranslators]);

  return (
    <>
      {showProfile && (
        <Profile
          user={profile}
          loading={false}
          setShowProfile={setShowProfile}
          usersLength={translators.length}
          counter={counter}
          noFxn
          admin
        />
      )}
      <div className="allocate position-fixed t-0 r-0 overflow-auto h-100 px-40 z-3">
        <h2
          className="allocate__head d-flex align-center font-subhead py-40 pointer"
          onClick={() => setShowAllocation(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "45px" }} />
          {quote.projectName}
        </h2>
        <div className="allocate__scroll">
          <div className="allocate__min__width">
            <div className="d-flex">
              <div className="allocate__top d-flex justify-between w-100 mb-20 p-20">
                <div className="d-flex flex-column">
                  <div className="d-flex pr-20">
                    <span className="pr-10">Subject: </span>
                    <span className="font-bolder">{quote.subject}</span>
                  </div>
                  <div className="d-flex pr-20">
                    <span className="pr-10">Category: </span>
                    <span className="font-bolder">{quote.category}</span>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <div className="d-flex pr-20">
                    <span className="pr-10">Delivery date: </span>
                    <span className="font-bolder">
                      {dayjs(quote.deliveryDate).fromNow()}
                    </span>
                  </div>
                  <div className="d-flex pr-20">
                    <span className="pr-10">Translation: </span>
                    {!allocations && !declined && (
                      <div className="d-flex font-bolder flex-column">
                        {quote.languageTo.map((language) => (
                          <span
                            key={language}
                          >{`${quote.languageFrom} to ${language}`}</span>
                        ))}
                      </div>
                    )}
                    {declined && (
                      <div className="d-flex font-bolder flex-column">
                        {quote.allocation.declined_lang.map((language) => (
                          <span
                            key={language}
                          >{`${quote.languageFrom} to ${language}`}</span>
                        ))}
                      </div>
                    )}
                    {allocations && (
                      <div className="d-flex font-bolder flex-column">
                        {quote.allocation.left_lang.map((language) => (
                          <span
                            key={language}
                          >{`${quote.languageFrom} to ${language}`}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <div className="d-flex pr-20">
                    <span className="pr-10">
                      {quote.totalPages ? "Total pages " : "Total words"}
                    </span>
                    <span className="font-bolder">
                      {quote.totalPages ? quote.totalPages : quote.totalCount}
                    </span>
                  </div>
                  <div className="d-flex pr-2">
                    <span className="pr-10">Amount paid: </span>
                    <span className="font-bolder">
                      ${(quote.amount / 100).toFixed(2)}
                    </span>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <div className="d-flex align-center">
                    <span className="pr-10">Review Date: </span>
                    <div>
                      <input
                        type="date"
                        className="border-0 outline-0 p-5"
                        value={reviewDate}
                        onChange={(e) => setReviewDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column">
                  {declined && (
                    <button
                      className="allocate__btn__msg border-0 outline-0 p-5 mb-10"
                      onClick={() => handleShowInfo("decline")}
                    >
                      Decline messages
                    </button>
                  )}
                  {quote.translatorNote !== "" && (
                    <button
                      className="allocate__btn__note border-0 outline-0 p-5"
                      onClick={() => handleShowInfo("note")}
                    >
                      Note
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="allocate__min__width d-flex my-40 f-100">
            <div className="d-flex flex-column w-100 f-70 p-20">
              <div className="d-flex w-100 mb-20">
                <span className="admin__serial font-bold">S/N</span>
                <div className="grid c-5 w-90 px-10">
                  <span className="font-bold">Name</span>
                  <span className="font-bold">Expertise</span>
                  <span className="font-bold">Native</span>
                  <span className="font-bold">Rating(Projects)</span>
                </div>
              </div>
              {loading ? (
                <div className="loader mx-auto">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              ) : (
                <>
                  {translators.length < 1 && (
                    <div className="font-bolder font-bigger text-center">
                      No eligible translator
                    </div>
                  )}
                  {translators.map((translator, index) => (
                    <div
                      className="admin__projects d-flex align-center pointer"
                      key={translator.name.concat(index)}
                    >
                      <span className="admin__serial font-bold">
                        {index + 1}
                      </span>
                      <div
                        style={{
                          boxShadow: declinedTranslators.includes(
                            translator.email
                          )
                            ? "0px 4px 6px crimson"
                            : "",
                        }}
                        className="grid align-center c-5 w-90 p-10 my-10 rounded box-shadow-lg"
                      >
                        <span
                          title={translator.name}
                          className="admin__projects__profile ellipsis pr-10"
                          onClick={() => handleOpenProfile(translator)}
                        >
                          {translator.name}
                        </span>
                        <span
                          title={translator.expertise.join(", ")}
                          className="text-uppercase ellipsis pr-10"
                        >
                          {translator.expertise.join(", ")}
                        </span>
                        <span
                          title={translator.native}
                          className="ellipsis pr-10"
                        >
                          {translator.native}
                        </span>
                        <span
                          title={`Rating, ${rating(translator)}; Completed, ${
                            translator.rating
                              ? translator.rating.total_rating
                              : 0
                          }`}
                        >
                          <b>{rating(translator)}</b>
                          {translator.rating
                            ? `(${translator.rating.total_rating})`
                            : "(0)"}
                        </span>
                        <div className="d-flex justify-center">
                          <button
                            className="border-0 outline-0 w-75 font-bold rounded"
                            onClick={() => handleSelect(translator)}
                            style={{
                              opacity: disableSelect(
                                translator._id,
                                translator.target_lang
                              )
                                ? "0.6"
                                : "",
                            }}
                            disabled={disableSelect(translator._id)}
                          >
                            Select
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
              {!loading && translators > 19 && (
                <div
                  className="d-flex justify-center p-20 pointer"
                  onClick={handleNextPage}
                >
                  <div className="d-flex align-center border-1 px-20 py-5 curved-20">
                    <span className="font-bold">View More</span>
                    <KeyboardArrowDown className="ml-5" fontSize="large" />
                  </div>
                </div>
              )}
            </div>
            <div className="allocate__selected position-sticky h-100 ml-40 f-30">
              <div className="d-flex flex-column justify-start align-center rounded border-1 box-shadow-lg p-10">
                <h2 className="py-20 mb-20">Selected</h2>
                {selected.length < 1 ? (
                  <div className="font-bolder font-bigger text-center">
                    No selected translator
                  </div>
                ) : (
                  <>
                    {selected.map((select, index) => (
                      <div
                        className="d-flex align-center justify-between p-10 border-1 curved-20 my-10 w-100"
                        key={select.name.concat(index)}
                      >
                        <img
                          className="rounded-50 mr-10"
                          src={select.profileImage}
                          alt=""
                        />
                        <div className="d-flex flex-column mr-10">
                          <span className="font-bold">
                            {select.source_lang} to {select.target_lang}
                          </span>
                          <span
                            title={select.name}
                            className="admin__projects__profile ellipsis pr-10"
                            onClick={() => handleOpenProfile(select)}
                          >
                            {select.name}
                          </span>
                          <div className="d-flex">
                            <span>Total:</span>
                            <span className="font-bolder ml-5">
                              ${" "}
                              {select.price
                                ? (
                                    select.price *
                                    (quote.totalPages
                                      ? quote.totalPages
                                      : quote.totalCount)
                                  ).toFixed(2)
                                : 0.0}
                            </span>
                          </div>
                        </div>
                        <div className="border-1 px-5">
                          <input
                            className="border-0 outline-0 w-45"
                            type="number"
                            placeholder="0.00"
                            onChange={(e) =>
                              handlePriceChange(index, e.target.value)
                            }
                          />
                          <small>
                            per {quote.totalPages ? "page" : "word"}
                          </small>
                        </div>
                        <sup
                          className="pointer"
                          onClick={() => removeTranslator(select._id)}
                        >
                          <CancelOutlined
                            className="hover-red"
                            style={{ fontSize: "16px" }}
                          />
                        </sup>
                      </div>
                    ))}
                    <button
                      style={{ opacity: disable ? "0.6" : "" }}
                      className="d-flex justify-center align-center my-20 p-10 w-100 font-big font-bold border-0 outline-0"
                      disabled={disable}
                      onClick={openModal}
                    >
                      Assign
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ right: showMessage ? 0 : "" }}
        className="project__declined__msg position-fixed h-100 t-0 z-4 overflow-auto"
      >
        <h3
          className="position-sticky d-flex align-center p-20 pointer border-bottom-1 t-0"
          onClick={() => setShowMessage(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "36px" }} />
          {infoType === "decline" && "Decline Message"}
          {infoType === "note" && "Note"}
        </h3>
        {infoType === "decline" &&
          errorMsg.map((msg) => (
            <div
              className="d-flex flex-column px-20 py-10 border-bottom-1"
              key={msg.message}
            >
              <span className="font-bold font-big">{msg.translator}</span>
              <span className="lh-lg">{msg.message}</span>
              <time className="font-sm font-bolder text-right">
                {dayjs(msg.createdAt).fromNow()}
              </time>
            </div>
          ))}
        {infoType === "note" && (
          <div className="d-flex flex-column px-20 py-10">
            <span className="font-bold font-big">Translator's Note</span>
            <span className="lh-lg">{quote.translatorNote}</span>
          </div>
        )}
      </div>
      <details className="allocate__details position-fixed">
        <summary className="list-none z-4"></summary>
        <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
          <div className="d-flex flex-column align-center text-center p-20">
            {
              <h3 className="font-subhead">
                Assigning project to{" "}
                {selected.map((translator) => translator.name).join(", ")}
              </h3>
            }
            <p className="font-heavy font-big py-40">
              You are assigning Project {quote.projectName} to{" "}
              {selected.map((translator) => translator.name).join(", ")} to be
              reveiwed on {dayjs(reviewDate).format("dddd, MMMM D YYYY")}
            </p>
            <div className="d-flex justify-between">
              <button
                className="allocate__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                style={{ opacity: disable ? "0.6" : "" }}
                className="allocate__btn__assign d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                disabled={disable}
                onClick={handleAllocate}
              >
                Assign
                {allocating && <div className="spin-white ml-10"></div>}
              </button>
            </div>
          </div>
        </div>
      </details>
    </>
  );
};

export default Allocate;
